function retrieveMinHours(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/min-hours`);
}

function updateMinHours(companyId, minHours) {
    return window.tenantAxios.patch(`/company/${companyId}/min-hours`, minHours);
}

export default {
    retrieveMinHours,
    updateMinHours,
};
